<template>
  <div class="content-single-5">
    <m-single-content-wrapper :contentLink="contentLink"
                              content-type="page">
      <template v-slot="{content}">
        <div class="row justify-content-center align-items-center p-2">
          <div class="col-lg-6 text-center mx-auto">
            <img :src="content.thumbnail" :alt="content.title"
                 class="mx-auto  content-single-5-image text-center" alt="">
          </div>
          <div class="col-lg-6 content-single-5-content-wrapper">
            <heading2 class="content-single-5-content-title">
              <template #p-1>{{ content.title }}</template>
              <template #p-2>
                {{content.keyword}}
                <span v-for="keyword in content.keywords" class="word">{{keyword.keyword}}</span>
              </template>
            </heading2>
            <div class="content-single-5-content-description" v-html="content.body"></div>
            <div class="container content-single-5-content-button">
              <m-a :href="findLinkOnContent(content.abstraction)">
                <m-button301 class="bg-primary" v-t="`content.single.more`"></m-button301>
              </m-a>
            </div>
          </div>
        </div>
      </template>
    </m-single-content-wrapper>
  </div>
</template>

<script>
import {ContentSingleProps} from "./ContentSingleProps";
import mSingleContentWrapper from "../../Wrappers/SingleContentWrapper";
import mA from "../../Tags/A";
import mButton2 from "../../Buttons/Button2";
import mCard906 from "../../Cards/Card906";
import mButton301 from "../../Buttons/Button301";
import Heading2 from "../../Heading/Heading2";

export default {
  name: "ContentSingle5",
  components: {Heading2, mA, mSingleContentWrapper, mButton2, mCard906, mButton301},
  props: {
    ...ContentSingleProps
  }
}
</script>

<style scoped>
.content-single-5-image {
  width: 100%;
}

.card906 >>> .card906-content .row {
  height: 100%;
  margin: auto;
}
</style>